module.exports = __webpack_public_path__ + "media/images/photo/any-photo-frame-4886f654f18042eb7c7d5f75567f9a29.png";